import axios from 'axios';
import * as Sentry from '@sentry/react';

const isPaid = async (id) => {
  const config = {
    method: 'GET',
    url: `${process.env.REACT_APP_BASE_URL}/transactions/${id}`,
    headers: {
      'content-type': 'application/json',
    },
  };

  return new Promise(async (resolve, reject) => {
    return await axios(config)
      .then((response) => resolve(response.data))
      .catch((error) => {
        const notpaid = error?.response?.data?.success === false;
        if (!notpaid) {
          Sentry.setContext('request', { config });
          Sentry.setContext('response', error.response.data);
          Sentry.captureMessage(config.url);
        }
        resolve({ success: false, data: error });
      });
  });
};

const transactions = async (data) => {
  const config = {
    method: 'POST',
    url: `${process.env.REACT_APP_BASE_URL}/straumann/transactions`,
    headers: {
      'content-type': 'application/json',
    },
    data,
  };
  return new Promise(async (resolve, reject) => {
    return await axios(config)
      .then((response) => resolve({ success: true, data: response.data }))
      .catch((error) => {
        Sentry.setContext('request', { config });
        Sentry.setContext('response', error.response.data);
        Sentry.captureMessage(config.url);
        resolve({ success: false, data: error.response.data });
      });
  });
};

const isBlockedByAdBlock = () => {
  return new Promise(async (resolve) => {
    try {
      window.Iugu.utils.isBlockedByAdBlock((response) => {
        resolve(response);
      });
    } catch (error) {
      resolve(false);
    }
  });
};

export { transactions, isPaid, isBlockedByAdBlock };
